import type { API } from '@/api';
import {
  getSelectedDurationInfo,
  isUnavailableSlot,
  shouldShowAsExtendedUnavailable,
} from '@/utils/timeSlotExtension';

type TimeSlot =
  API['GET']['PrivateRoomAvailableTimeSlots']['response']['spaces'][number]['time_slots'][number];

/**
 * 防音個室ブースのタイムバーのクラス名を計算するhook
 */
export const usePrivateRoomTimeBarClasses = (
  timeSlots: TimeSlot[],
  selectedStartTime?: `${string}:${string}`,
  selectedDurationMinutes?: number,
) => {
  /**
   * タイムスロットのクラス名を取得する
   * @param slot - タイムスロット
   * @param index - スロットのインデックス
   * @returns クラス名の文字列
   */
  const getSlotClasses = (slot: TimeSlot, index: number): string => {
    const classes = ['booth-time-slot'];

    // 時間・半時間のマーカー（時刻の分で判定）
    const minutes = parseInt(slot.time.split(':')[1], 10);
    if (minutes === 0) {
      classes.push('booth-time-slot-one-hour');
    } else if (minutes === 30) {
      classes.push('booth-time-slot-half-hour');
    }

    // 利用不可スロットの判定と拡張表示
    const slotIsUnavailable = isUnavailableSlot(slot);

    if (slotIsUnavailable) {
      classes.push('booth-time-slot-unavailable');
    } else if (shouldShowAsExtendedUnavailable(timeSlots, index)) {
      // 短い利用不可区間（5分・10分）の拡張表示
      classes.push('booth-time-slot-unavailable');
    }

    // 選択された期間のスロット
    if (selectedStartTime && selectedDurationMinutes) {
      const durationInfo = getSelectedDurationInfo(
        timeSlots,
        index,
        selectedStartTime,
        selectedDurationMinutes,
      );

      if (durationInfo.isInSelectedDuration) {
        classes.push('selected-duration');

        if (durationInfo.isExtendedPart) {
          classes.push('booth-time-slot-unavailable');
        }
      }
    }

    return classes.join(' ');
  };

  return {
    getSlotClasses,
  };
};
